import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const variantClasses = {
    primary: "bg-[var(--color-primary)] text-[var(--color-primary-foreground)] hover:opacity-90",
    secondary: "bg-[var(--color-secondary)] text-[var(--color-secondary-foreground)] hover:bg-[var(--color-accent)]",
    ghost: "hover:bg-[var(--color-accent)] text-[var(--color-foreground)]",
    danger: "bg-[var(--color-destructive)] text-[var(--color-destructive-foreground)] hover:opacity-90",
};
const sizeClasses = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
};
export function Button({ children, variant = "primary", size = "md", disabled = false, loading = false, type = "button", onClick, className = "", }) {
    return (_jsxs("button", { type: type, disabled: disabled || loading, onClick: onClick, className: [
            "inline-flex items-center justify-center rounded-[var(--radius-md)] font-medium transition-colors",
            "disabled:opacity-50 disabled:cursor-not-allowed",
            variantClasses[variant],
            sizeClasses[size],
            className,
        ].join(" "), children: [loading ? (_jsx("span", { className: "mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" })) : null, children] }));
}
